import runpodSdk from 'runpod-sdk'

const RUNPOD_API_TOKEN = process.env.RUNPOD_API_TOKEN ?? '26AFG34MX8NT1QCWHWG3VSSKHJKZGE89SQM7RZ5K'

export const runpod = runpodSdk(RUNPOD_API_TOKEN)
